// Author Shi Wen Long
// Date 2024-12-20 15:43:31

class SithMesPrdZpp2MaterialsDetail {
    constructor({
                    id = null,
                    materialNumber = '',
                    quantity = '',
                    zpp2Id = '',
                    remark = ''
                }
                = {}) {
        this.id = id;
        this.materialNumber = materialNumber;
        this.quantity = quantity;
        this.zpp2Id = zpp2Id;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesPrdZpp2MaterialsDetail();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialNumber',
            label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.grid.materialNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'zpp2Id',
            label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.grid.zpp2Id',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    materialNumberFilter: '',
    quantityFilter: '',
    zpp2IdFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'materialNumberFilter',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'zpp2IdFilter',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.filter.zpp2Id',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'zpp2Id',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.entity.zpp2Id',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdZpp2MaterialsDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesPrdZpp2MaterialsDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
